export default "__VITE_ASSET__kxyUnTlO__"